function mmInitSplide() {
  const splideElem = document.querySelector(".splide-mm-cart");
  splideElem &&
    new Splide(splideElem, {
      type: "loop",
      arrows: !1,
      pagination: !1,
      gap: 20,
      padding: { right: "40px", left: "0" },
    }).mount();
}
function mmInitSplideUpsell() {
  const splideElem = document.querySelector("#splide_upsell");
  if (splideElem) {
    const swiper = new Swiper(splideElem, {
      direction: "horizontal",
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 10,
    });
  }
}
mmInitSplideUpsell(),
  document.addEventListener(
    "DOMContentLoaded",
    () => {
      mmInitSplide(),
        mmCalculeHeigh(),
        window.addEventListener("resize", () => {
          mmCalculeHeigh();
        });
    },
    { once: !0 }
  ),
  (mmCalculeHeigh = () => {
    let upsellHeight2 = 0,
      headerHeight = 0,
      bottomHeight = 0;
    document.querySelector(".mm-dc-cross-sell") &&
      (document.querySelector(".mm-dc-cross-sell").classList.contains("hidden")
        ? (upsellHeight2 = 20)
        : (upsellHeight2 =
          document.querySelector(".mm-dc-cross-sell").offsetHeight)),
      document.querySelector(".mm-dc-cross-sell") &&
      (headerHeight =
        document.querySelector(".mm-dc-free-item-progress").offsetHeight +
        document.querySelector(".mm-dc-free-item-progress-text")
          .offsetHeight +
        document.querySelector(".mm-dc-header").offsetHeight),
      document.querySelector(".footer-bottom") &&
      (bottomHeight = document.querySelector(".footer-bottom").offsetHeight);
    let totalHeight = headerHeight + upsellHeight2 + bottomHeight - 20;
    document.documentElement.style.setProperty(
      "--upsell-height",
      `${totalHeight}px`
    );
  }),
  (initSellingPlan = () => {
    document
      .querySelectorAll(
        ".mm-drawer-cart .sidecart-product-pack__subscription-current"
      )
      .forEach((elem) => {
        console.log(elem),
          elem.addEventListener("click", () => {
            elem
              .closest(".sidecart-product-pack__subscription-select")
              .classList.toggle("actif");
          });
        let selling_container = elem.closest(
          ".sidecart-product-pack__subscription-select"
        );
        selling_container
          .querySelectorAll(
            ".sidecart-product-pack__subscription-select-values label"
          )
          .forEach(function (label) {
            label.addEventListener("click", function (e) {
              let selling_plan_id = e.currentTarget
                .getAttribute("for")
                .split("_")[2],
                subscription_current = selling_container.querySelector(
                  ".sidecart-product-pack__subscription-current-value"
                ),
                selling_plan_value = e.currentTarget.innerText;
              (subscription_current.innerText = selling_plan_value),
                console.log(selling_plan_id),
                mmAPIRequest("POST", "cart/change.js", {
                  line: elem
                    .closest(".mm-dc-product")
                    .getAttribute("line-item"),
                  quantity: parseInt(
                    elem
                      .closest(".mm-dc-product")
                      .getAttribute("data-item-quantity")
                  ),
                  selling_plan: selling_plan_id,
                  sections: "mm-cart",
                }).then(insertCartProductsFromResponse),
                elem
                  .closest(".sidecart-product-pack__subscription-select")
                  .classList.toggle("actif");
            });
          });
      });
  }),
  initSellingPlan();
function debounce(func, duration) {
  let timeout;
  return (
    console.log("debounce", func, duration),
    function (...args) {
      const effect = () => ((timeout = null), func.apply(this, args));
      clearTimeout(timeout), (timeout = setTimeout(effect, duration));
    }
  );
}
function mmCartSectionElement() {
  return document.getElementById("shopify-section-mm-cart");
}
function mmCartProductsContainerElement() {
  return mmCartSectionElement().querySelector(".mm-dc-products-container");
}
function mmCartItem(productVariantId) {
  return mmCartProductsContainerElement().querySelector(
    `[data-cart-item-id="${productVariantId}"]`
  );
}
function mmCartItemQuantityEl(productVariantId) {
  return mmCartItem(productVariantId).querySelector("[data-item-quantity]");
}
function mmGetCartItemQuantity(productVariantId) {
  const quantityEl = mmCartItemQuantityEl(productVariantId);
  return Number.parseInt(quantityEl.dataset.itemQuantity);
}
function mmSetCartItemQuantity(productVariantId, newQuantity) {
  if (newQuantity >= 0) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);
    (quantityEl.dataset.itemQuantity = newQuantity),
      (quantityEl.innerText = newQuantity);
  }
}
function mmCartHTMLFromData(data) {
  const el = document.createElement("DIV");
  return (el.innerHTML = data.sections["mm-cart"]), el;
}
function extractItemsFromCartHTML(data) {
  return mmCartHTMLFromData(data).querySelector(".mm-dc-products-container");
}
function extractCrossSellFromCartHTML(data) {
  const el = mmCartHTMLFromData(data);
  return mmCalculeHeigh(), el.querySelector(".mm-dc-cross-sell");
}

function extractPrices(data) {
  const el = mmCartHTMLFromData(data);
  return el.querySelector(".mm-dc-bottom");
}

function insertCartProductsFromResponse(data) {
  const prices = extractPrices(data);
  if (document.querySelector('bundle-section')) {
    document.querySelector('bundle-section').dataset.cartAmmount = data.total_price;
  }
  document.querySelector(".mm-dc-bottom").innerHTML = prices.innerHTML;
  const itemsContainer = extractItemsFromCartHTML(data);
  mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
  const crossSellContainer = extractCrossSellFromCartHTML(data),
    crossSellEl = mmCartSectionElement().querySelector(".mm-dc-cross-sell");
  return (
    crossSellContainer &&
    (crossSellEl.outerHTML = crossSellContainer.outerHTML),
    mmCalculeHeigh(),
    initAddEvent(),
    mmInitSplideUpsell(),
    initSellingPlan(),
    initChildObserver(),
    dispatchNewItemsEvent(),
    data
  );
}
function extractTotalPriceFromCartHTML(data) {
  return mmCartHTMLFromData(data).querySelector("[data-cart-total-price]");
}
function insertInsertTotalPriceFromResponse(data) {
  console.log(data);
  const newTotalPriceEl = extractTotalPriceFromCartHTML(data),
    currentTotalPriceEl = mmCartSectionElement().querySelector(
      "[data-cart-total-price]"
    );
  return (currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML), data;
}
function mmAPIRequest(method, path, body) {
  return (
    document.querySelector(".mm-dc-products").classList.add("mm-inactive"),
    fetch(window.Shopify.routes.root + path, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (
          (document
            .querySelector(".mm-dc-products")
            .classList.remove("mm-inactive"),
            mmCartSectionElement().querySelector(
              ".mm-dc-free-item-progress--inner"
            ))
        ) {
          const freeItemsProgress = mmCartSectionElement().querySelector(
            ".mm-dc-free-item-progress--inner"
          ),
            newWidth =
              (data.total_price /
                document.getElementById("mmCartProgressBarValue").value) *
              100;
          (freeItemsProgress.style.width = `${newWidth}%`),
            console.log(),
            data.total_price >=
              document.getElementById("mmCartProgressBarValue").value
              ? ((document.querySelector(
                ".mm-dc-free-item-progress-text_succes"
              ).style.display = "block"),
                (document.querySelector(
                  ".mm-dc-free-item-progress-text_not_yet"
                ).style.display = "none"))
              : ((document.querySelector(
                ".mm-dc-free-item-progress-text_succes"
              ).style.display = "none"),
                (document.querySelector(
                  ".mm-dc-free-item-progress-text_not_yet"
                ).style.display = "block"));
          const montantRestant = document.querySelector(
            ".mm-dc-free-item-progress-text span"
          );
          montantRestant &&
            (montantRestant.innerText = (
              (document.getElementById("mmCartProgressBarValue").value -
                data.total_price) /
              100
            ).toFixed(2));
        }
        return data;
      })
      .then((data) => {
        if (data.status && data.status > 400) throw data;
        return data;
      })
  );
}
function mmGetCart() {
  mmAPIRequest("GET", "cart.js").then(console.log);
}

function mmOpenCart() {
  document
    .querySelector(".mm-drawer-cart-filter")
    .classList.add("mm-dc-is-open"),
    document.querySelector("html").classList.add("stop-scrolling");
}
function mmCloseCart() {
  document
    .querySelector(".mm-drawer-cart-filter")
    .classList.remove("mm-dc-is-open"),
    document.querySelector("html").classList.remove("stop-scrolling");
}
function refreshCartFromData(data) {
  console.log(data);
  if (document.querySelector('bundle-section')) {
    document.querySelector('bundle-section').dataset.cartAmmount = data.total_price;
  }
  const newCartEl = document.createElement("DIV");
  newCartEl.innerHTML = data.sections["mm-cart"];
  const innerCart = mmCartSectionElement().querySelector(
    ".mm-drawer-cart-filter"
  );
  (innerCart.innerHTML = newCartEl.querySelector(
    ".mm-drawer-cart-filter"
  ).innerHTML),
    initAddEvent(),
    mmInitSplide(),
    initSellingPlan(),
    mmInitSplideUpsell(),
    mmCalculeHeigh(),
    initChildObserver(),
    dispatchNewItemsEvent(),
    refreshProgressBar();
}

function dispatchNewItemsEvent() {
  fetch("/cart.json")
    .then((res) => res.json())
    .then((data) => {
      // calcule cart items quantity 
      let cartItemsQuantity = 0;
      data.items.forEach(item => {
        cartItemsQuantity += item.quantity;
      });
      console.log(cartItemsQuantity);
      document.querySelector('[data-cart-count] span').innerText = cartItemsQuantity;
      document.querySelector('.mm-cart-count-bubble').innerText = cartItemsQuantity;
    })
}

function mmAddProductToCart(productId, { quantity = 1, openCart = !0 }) {
  mmAPIRequest("POST", "cart/add.js", {
    items: [{ quantity, id: productId }],
    sections: "mm-cart",
  })
    .then(refreshCartFromData)
    .then((data) => {

      openCart && setTimeout(mmOpenCart), mmCalculeHeigh();

    })
    .catch((error) => {
      (mmCartProductsContainerElement().innerHTML = `
    Oups, il y a eu une erreur, essayez de recharger la page !
    `),
        mmOpenCart(),
        console.log(error);
    });
}

async function mmRemoveProductsFromCart(ids) {
  let itemsToRemove = document.querySelector('[data-items-to-remove]').dataset.itemsToRemove;
  let items = itemsToRemove.split(', ');
  console.log(items);
  //  remove empty items
  items = items.filter(item => item != "");

  const updates = items.reduce((acc, id) => {
    acc[id] = 0;
    return acc;
  }, {});


  const updateResponse = await fetch('/cart/update.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates, sections: "mm-cart" }),
  });

  if (!updateResponse.ok) {
    throw new Error(`ERROR : ${updateResponse.statusText}`);
  }

  refreshCartFromData(await updateResponse.json());

}



function mmIncreaseProductQuantity(productVariantId) {
  const newQuantity = mmGetCartItemQuantity(productVariantId) + 1;
  mmSetCartItemQuantity(productVariantId, newQuantity),
    mmDebouncedPushNewQuantity(productVariantId);
}
function mmDecreaseProductQuantity(productVariantId) {
  const newQuantity = mmGetCartItemQuantity(productVariantId) - 1;
  mmSetCartItemQuantity(productVariantId, newQuantity),
    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
  mmSetCartItemQuantity(productVariantId, 0),
    mmDebouncedPushNewQuantity(productVariantId);
}
function mmPushNewQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);
  mmAPIRequest("POST", "cart/change.js", {
    id: productVariantId.toString(),
    quantity,
    sections: "mm-cart",
  })
    .then(insertCartProductsFromResponse)
    .then(mmAddOrRemoveFreeProducts),
    mmCalculeHeigh();
}
const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
  mmPushNewQuantity(productVariantId);
}, 300);
function mmAddOrRemoveFreeProducts(data) {
  if (data.sections["mm-cart"]) {

  }
  return data;
}
function mmProgressBar() { }
initAddEvent();
let upsellHeight = document.querySelector(".mm-dc-cross-sell").innerHeight;
document.documentElement.style.setProperty(
  "--upsell-height",
  `${upsellHeight}px`
),
  console.log(upsellHeight);
function initAddEvent() {
  document.querySelectorAll(".toggle-container").forEach((elem) => {
    elem.addEventListener("click", () => {
      console.log(
        elem.closest(".mm-dc-product").getAttribute("data-cart-item-id")
      );
      var url = "cart/change.js";
      elem.querySelector("input").getAttribute("checked") === "unchecked"
        ? (elem.querySelector("input").setAttribute("checked", "checked"),
          mmAPIRequest("POST", "cart/change.js", {
            line: elem.closest(".mm-dc-product").getAttribute("line-item"),
            quantity: parseInt(
              elem.closest(".mm-dc-product").getAttribute("data-item-quantity")
            ),
            selling_plan: elem
              .closest(".mm-dc-product")
              .querySelector("[data-good-selling-plan]").value,
            sections: "mm-cart",
          }).then(insertCartProductsFromResponse))
        : (elem.querySelector("input").setAttribute("checked", "unchecked"),
          mmAPIRequest("POST", "cart/change.js", {
            line: elem.closest(".mm-dc-product").getAttribute("line-item"),
            quantity: parseInt(
              elem.closest(".mm-dc-product").getAttribute("data-item-quantity")
            ),
            selling_plan: null,
            sections: "mm-cart",
          }).then(insertCartProductsFromResponse)),
        console.log(elem.querySelector("input").getAttribute("checked"));
    });
  });
}

class CountDown {
  constructor(element) {
    this.element = element;
    this.countDown = true;
    this.initCountDown();
  }

  async initCountDown() {
    console.log("INIT COUNTDOWN");

    const countDown = this.element.getAttribute("count-down");
    const countDownDate = new Date(countDown).getTime();

    const countDownInterval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;

      // Calculations for days, hours, and minutes
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      hours += days * 24;

      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      // Formatting digits
      const formatNumber = (num) => num.toString().padStart(2, "0");
      const splitHours = formatNumber(hours).split("");
      const splitMinutes = formatNumber(minutes).split("");

      if (hours > 100) {
        // Update the element's inner HTML
        this.element.innerHTML = `
        <div class="count-down" id="countdown1">
          <div class="count-down-item">
            <span class="digit">${splitHours[0]}</span>
            <span class="digit">${splitHours[1]}</span>
            <span class="digit">${splitHours[2]}</span>
          </div>
          <span class="separator-v2">:</span>
          <div class="count-down-item">
            <span class="digit">${splitMinutes[0]}</span>
            <span class="digit">${splitMinutes[1]}</span>
          </div>
        </div>
      `;
      }
      else {
        // Update the element's inner HTML
        this.element.innerHTML = `
        <div class="count-down" id="countdown1">
          <div class="count-down-item">
            <span class="digit">${splitHours[0]}</span>
            <span class="digit">${splitHours[1]}</span>
          </div>
          <span class="separator-v2">:</span>
          <div class="count-down-item">
            <span class="digit">${splitMinutes[0]}</span>
            <span class="digit">${splitMinutes[1]}</span>
          </div>
        </div>
      `;
      }


      // Handle expiration
      if (distance < 0) {
        clearInterval(countDownInterval);
        this.countDown = false;
        this.element.style.display = 'none';
      }
    }, 100);

    if (this.countDown) {
      console.log("Countdown is running");

      const productId = this.element.getAttribute("product-id");
      console.log(productId);

      const isProductInCart = async (productId) => {
        const response = await fetch("/cart.json");
        if (!response.ok) {
          throw new Error(
            `Erreur lors de la récupération du panier : ${response.statusText}`
          );
        }
        const cartData = await response.json();
        return cartData.items.some((item) => item.variant_id == productId);
      };

      try {
        const productInCart = await isProductInCart(productId);

        if (!productInCart) {
          const url = "/cart/update.js";
          const updates = { [productId]: 1 };

          const updateResponse = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates }),
          });

          if (!updateResponse.ok) {
            throw new Error(`ERROR : ${updateResponse.statusText}`);
          }

          refreshCartFromData(await updateResponse.json());
        } else {
          console.log("Product Already in cart");
        }
      } catch (error) {
        console.error("Erreur :", error);
      }
    } else {
      const productId = this.element.getAttribute("product-id");
      const cartItems = document.querySelectorAll(".mm-dc-product");
      cartItems.forEach((cartItem) => {
        if (cartItem.getAttribute("data-cart-item-id-free") == productId) {
          mmDestroyProductFromCart(productId);
        }
      });
    }
  }
}

const countDownElements = document.querySelectorAll("count-down-v2");
countDownElements.forEach((element) => new CountDown(element));


function handleChildrenChange(mutationsList) {
  mutationsList.forEach(mutation => {
    if (mutation.type === 'childList') {
      refreshProgressBar();
    }
  });
}

function initChildObserver() {
  const container = document.querySelector(".mm-drawer-cart");
  if (!container) return;

  const observer = new MutationObserver(handleChildrenChange);

  observer.observe(container, {
    childList: true,
    subtree: false,
  });
}

function refreshProgressBar() {
  if (document.querySelector('bundle-section')) {
    document.querySelector('quantity-inputs').udateProgressBar(0);
  }
}

initChildObserver()